import { Translations } from "../../models/locale";

import enUS from "./en-US.json";
import enCA from "./en-CA.json";
import frCA from "./fr-CA.json";
import ptBR from "./pt-BR.json";

const translations: Translations = {
  "en-US": enUS,
  "en-CA": enCA,
  "fr-CA": frCA,
  "pt-BR": ptBR,
};

export default translations;
